import { useMemo } from 'react'

import { StorableType, BaseValue } from '../validation'
import { UseUrlHookOptions, useUrlStorageState as useUrlQueryStorage } from './useUrlStorageState'

type ReducedOptions<TType extends StorableType, TValue extends BaseValue<TType>> = Omit<
  UseUrlHookOptions<TType, TValue>,
  'type'
>

export function createUrlStorageHook<TType extends StorableType, TValue extends BaseValue<TType>>(
  key: string,
  options: UseUrlHookOptions<TType, TValue>,
) {
  return function useExtendedQueryState(externalOptions?: ReducedOptions<TType, TValue>) {
    const storageOptions = useMemo((): UseUrlHookOptions<TType, TValue> => {
      return {
        ...options,
        ...externalOptions,

        type: options.type,
      }
    }, [externalOptions])

    return useUrlQueryStorage(key, storageOptions)
  }
}
